// Contexto de Tema para la aplicación Amarsi Control Panel
// Maneja el estado global del tema (claro/oscuro) y proporciona métodos para cambiarlo

import React, { createContext, useContext, useState, useEffect } from 'react';

// Constante para controlar logs de desarrollo
const DEBUG = process.env.NODE_ENV === 'development';

// Creación del contexto
const ThemeContext = createContext();

// Hook personalizado para usar el contexto de tema
export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme debe ser usado dentro de un ThemeProvider');
  }
  return context;
};

// Provider del contexto de tema
export const ThemeProvider = ({ children }) => {
  // Estado local para el tema (por defecto 'dark')
  const [theme, setTheme] = useState(() => {
    // Recupera el tema guardado en localStorage o usa 'dark' por defecto
    const savedTheme = localStorage.getItem('theme');
    return savedTheme || 'dark';
  });

  // Efecto para aplicar el tema al documento y guardarlo en localStorage
  useEffect(() => {
    // Aplica la clase 'dark' al elemento html cuando el tema es oscuro
    const root = document.documentElement;
    if (theme === 'dark') {
      root.classList.add('dark');
    } else {
      root.classList.remove('dark');
    }
    
    // Guarda el tema en localStorage
    localStorage.setItem('theme', theme);
    
    if (DEBUG) console.log('ThemeContext: Tema cambiado a', theme);
  }, [theme]);

  // Función para alternar entre tema claro y oscuro
  const toggleTheme = () => {
    setTheme(prevTheme => prevTheme === 'dark' ? 'light' : 'dark');
  };

  // Objeto de valor del contexto
  const value = {
    theme,
    toggleTheme,
    isDark: theme === 'dark',
  };

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
};
